import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  hideViewMaintenanceRequestModal,
  clearMaintenanceRequestText,
} from "../redux-state/features/maintenance/maintenanceSlice";
const ViewMaintenanceRequestModal = ({}) => {
  const dispatch = useDispatch();
  const { maintenanceRequestText, viewMaintenanceRequestModal } = useSelector(
    (state) => state.maintenanceState
  );
  const handleClose = () => {
    dispatch(clearMaintenanceRequestText());
    dispatch(hideViewMaintenanceRequestModal());
  };

  return (
    <>
      <Modal show={viewMaintenanceRequestModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "12px" }}>
            {" "}
            تفاصيل الخدمة المطلوبة
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center">{maintenanceRequestText}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewMaintenanceRequestModal;
